"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
exports.useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        width: 200,
        textAlign: 'center',
    },
    image: {
        maxHeight: 128,
        maxWidth: 180,
        marginBottom: theme.spacing(2),
    },
}); });
var MarketingFeature = function (_a) {
    var classNameProp = _a.className, description = _a.description, heading = _a.heading, image = _a.image, other = __rest(_a, ["className", "description", "heading", "image"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        react_1.default.createElement("div", { className: classes.image }, image),
        react_1.default.createElement(Typography_1.default, { gutterBottom: true, variant: "h3", color: "textSecondary" }, heading),
        react_1.default.createElement(Typography_1.default, { variant: "caption" }, description)));
};
exports.default = MarketingFeature;
//# sourceMappingURL=MarketingFeature.js.map